import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import { call_api, getIdUsuario } from "../../requests/utils";
import "./styles.css";

const ModalPermisos = ({ isOpen, onClose, infoUser, onSubmit }) => {
  const [vistas, setVistas] = useState(null);
  const [indexShow, setIndexShow] = useState(null);
  const [permisos, setPermisos] = useState([]);
  const [itemSelect, setItemSelect] = useState(null);
  useEffect(() => {
    getPermisos();
  }, []);

  const getPermisos = async () => {
    let config_api = {
      IdUsuario: parseInt(infoUser.idUsuario),
      IdUsuarioAct: parseInt(getIdUsuario()),
    };
    let response = await call_api({
      method: "POST",
      endpoint: "System/obtenerReportesTodas",
      data: config_api,
    });

    if (response && response.code === 0) {
      setVistas(response.data);
      let newPermisos = response.data.map((item) => {
        return {
          idVista: item.idVista,
          idUsuario: infoUser.idUsuario,
          IdUsuarioAct: parseInt(getIdUsuario()),
          permiso: item.asignado ? 1 : 0,
          vistaPadre: item.vistaPadre,
        };
      });
      setPermisos(newPermisos);
    }
  };

  const onAddRemove = (idVista, checked, parentId) => {
    //se va verificar si ya existe en el principal
    let findBd = vistas.find((item) => item.idVista === idVista);

    //se revisa si ya esta en la lista de permisos
    let indexFind = permisos.findIndex((item) => item.idVista === idVista);

    let permisoItem = {
      idVista,
      idUsuario: infoUser.idUsuario,
      IdUsuarioAct: parseInt(getIdUsuario()),
      permiso: checked ? 1 : 0,
      vistaPadre: parentId,
    };

    if (indexFind > -1) {
      let newPermisos = [...permisos];
      newPermisos[indexFind] = permisoItem;
      setPermisos(newPermisos);
    } else {
      setPermisos([...permisos, permisoItem]);
    }
  };
  const onSubmit_ = async () => {
    let sendPermisos = [...permisos];
    //obtener padres
    let padres = permisos.filter((item) => item.vistaPadre === 0);
    for (let row of padres) {
      let childs = sendPermisos.filter(
        (item) => item.vistaPadre === row.idVista && item.permiso === 1
      );
      let indexFindParent = sendPermisos.findIndex(
        (item) => item.idVista === row.idVista
      );
      if (childs.length === 0) {
        if (indexFindParent > -1) {
          let parentFind = sendPermisos[indexFindParent];
          parentFind.permiso = 0;
          sendPermisos[indexFindParent] = parentFind;
        }
      } else if (childs.length > 0) {
        if (indexFindParent > -1) {
          let parentFind = sendPermisos[indexFindParent];
          parentFind.permiso = 1;
          sendPermisos[indexFindParent] = parentFind;
        }
      }
    }

    /*
    sirve para verificar los permisos
     let testParent = sendPermisos.find((item) => item.idVista === 1);
     console.log(testParent);
     let testHijos = sendPermisos.filter((item) => item.vistaPadre === 1);
     console.log(testHijos);
     */
    onSubmit(sendPermisos);
  };

  const renderItems = (parentId) => {
    return vistas
      .filter((item) => item.vistaPadre === parentId)
      .map((item, index) => (
        <div
          className={
            "item-row " + (item.idVista === itemSelect?.idVista ? "active" : "")
          }
        >
          {/*
          <button
            onClick={() => {
              //futuro cambio
              let select = null;
              if(item.idVista  !== itemSelect?.idVista){
                select = item;
              }
              setItemSelect(select)
            
            }}
            key={`${parentId}_${index}`}
          >
          
          */}
          <strong>{item.nombreVista}</strong>
          <div className={"asignar_check"}>
            <input
              type="checkbox"
              id={`chk_${item.idVista}_${index}`}
              onChange={(e) =>
                onAddRemove(item.idVista, e.target.checked, parentId)
              }
              defaultChecked={item?.asignado}
            />
            <label htmlFor={`chk_${item.idVista}_${index}`}>
              <span></span>
            </label>
          </div>
          {/* </button>*/}
        </div>
      ));
  };
  return (
    <div className={"root"}>
      <h3 className={"title"}>
        Administración de reportes a {infoUser.nombre.toUpperCase()}
      </h3>
      <div className={"container-root"}>
        <FormGroup row>
          {vistas
            ? vistas
                .filter((item) => item.vistaPadre === 0)
                .map((item, index) => (
                  <div className={"item-col"}>
                    <button
                      onClick={() => {
                        let setIndex = null;
                        if (indexShow !== index) {
                          setIndex = index;
                        }
                        setIndexShow(setIndex);
                        setItemSelect(null);
                      }}
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          (indexShow === index
                            ? "/images/icon_arrow_up.png"
                            : "/images/icon_arrow_down.png")
                        }
                        alt={""}
                      />
                      <span>{item.nombreVista}</span>
                    </button>
                    <div
                      className={"container-rows"}
                      style={{
                        display: index === indexShow ? "block" : "none",
                      }}
                    >
                      <div className={"reportes"}>
                        {renderItems(item.idVista)}
                      </div>
                      {itemSelect ? (
                        <div
                          className={"permisos"}
                          style={{
                            minHeight: `${
                              vistas.filter(
                                (sub) => sub.vistaPadre === item.idVista
                              ).length * 53
                            }px`,
                          }}
                        >
                          <div className={"asignar_check"}>
                            <input
                              type="checkbox"
                              id={`chk_${item.idVista}_${index}`}
                              onChange={(e) => {}}
                              defaultChecked={itemSelect?.asignado}
                            />
                            <label htmlFor={`chk_${item.idVista}_${index}`}>
                              <span></span>
                            </label>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                ))
            : null}
          <div className={"buttons_"}>
            <Button color="primary" onClick={() => onSubmit_()}>
              Guardar cambios
            </Button>
            <Button color="secondary" onClick={() => onClose()}>
              Cancelar
            </Button>
          </div>
        </FormGroup>
      </div>
    </div>
  );
};

export default ModalPermisos;
